export default {
 account : {
  email               : null,
  nameSurname         : null,
  auth                : {
      isLoggedIn          : false,
      isAuth              : false,
      loginTime           : null,
      token               : null,
  },
 }
}